import { render, staticRenderFns } from "./VxImageUploader.vue?vue&type=template&id=4422b722&scoped=true&"
import script from "./VxImageUploader.vue?vue&type=script&lang=js&"
export * from "./VxImageUploader.vue?vue&type=script&lang=js&"
import style0 from "./VxImageUploader.vue?vue&type=style&index=0&id=4422b722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4422b722",
  null
  
)

export default component.exports